export const ClientGroupType = {
  GROUP_OF_CLIENTS: 'group_of_clients',
  GROUP_OF_CLIENT_GROUPS: 'group_of_client_groups',
};

export const ClientGroupRoute = {
  CLIENTGROUPS: 'clientgroups',
};

export const ClientGroupPathName = {
  CLIENTGROUPS: 'clientgroups',
  CLIENTGROUPFORM_NEW: 'clientgroupform:new',
  CLIENTGROUPFORM: 'clientgroupform',
};
